import { gql } from 'graphql-request'

export const ACCEPT_ADMIN = gql`
  mutation AcceptAdmin($acceptAdminInput: AcceptAdminInput!) {
    acceptAdmin(acceptAdminInput: $acceptAdminInput) {
      id
    }
  }
`
